module.exports = __webpack_public_path__ + "img/wxzj.a109bd62.png";